<script lang="ts">
    export let password: string;
    export let attrs: any;

    let isNewPasswordVisible = false;
</script>

<div class="relative">
    {#if isNewPasswordVisible}
        <div class="flex w-full justify-between">
            <input {...attrs} type="text" bind:value={password} autocomplete="new-password" class="input mt-0.5" />
            <button
                type="button"
                class="absolute right-2 h-full"
                on:click={() => (isNewPasswordVisible = !isNewPasswordVisible)}
                aria-label={isNewPasswordVisible ? 'Hide password' : 'Show password'}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                    <path
                        d="M1.18376 10.495C0.966134 10.271 0.789849 10.0789 0.65907 9.93197C0.789849 9.78506 0.966134 9.59292 1.18376 9.36893C1.70253 8.83497 2.4533 8.12302 3.3798 7.41194C5.24477 5.9806 7.76198 4.59863 10.5 4.59863C13.238 4.59863 15.7552 5.9806 17.6202 7.41194C18.5467 8.12302 19.2975 8.83497 19.8162 9.36893C20.0339 9.59292 20.2101 9.78506 20.3409 9.93197C20.2101 10.0789 20.0339 10.271 19.8162 10.495C19.2975 11.029 18.5467 11.7409 17.6202 12.452C15.7552 13.8833 13.238 15.2653 10.5 15.2653C7.76198 15.2653 5.24477 13.8833 3.3798 12.452C2.4533 11.7409 1.70253 11.029 1.18376 10.495Z"
                        stroke="#477785"
                    />
                    <path
                        d="M14.2704 9.93012C14.2704 12.0165 12.579 13.7079 10.4926 13.7079C8.40621 13.7079 6.71484 12.0165 6.71484 9.93012C6.71484 7.84371 8.40621 6.15234 10.4926 6.15234C12.579 6.15234 14.2704 7.84371 14.2704 9.93012Z"
                        stroke="#477785"
                    />
                    <circle cx="9.13411" cy="8.5638" r="1.83333" stroke="#477785" />
                    <rect
                        x="2.20711"
                        y="18"
                        width="24.0422"
                        height="2"
                        transform="rotate(-45 2.20711 18)"
                        fill="#477785"
                        stroke="#FDFCFD"
                    />
                </svg>
            </button>
        </div>
    {:else}
        <div class="flex w-full account-input justify-between">
            <input {...attrs} type="password" bind:value={password} autocomplete="new-password" class="input mt-0.5" />
            <button
                class="absolute right-2 h-full"
                type="button"
                on:click={() => (isNewPasswordVisible = !isNewPasswordVisible)}
                aria-label={isNewPasswordVisible ? 'Hide password' : 'Show password'}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                    <path
                        d="M1.18376 10.495C0.966134 10.271 0.789849 10.0789 0.65907 9.93197C0.789849 9.78506 0.966134 9.59292 1.18376 9.36893C1.70253 8.83497 2.4533 8.12302 3.3798 7.41194C5.24477 5.9806 7.76198 4.59863 10.5 4.59863C13.238 4.59863 15.7552 5.9806 17.6202 7.41194C18.5467 8.12302 19.2975 8.83497 19.8162 9.36893C20.0339 9.59292 20.2101 9.78506 20.3409 9.93197C20.2101 10.0789 20.0339 10.271 19.8162 10.495C19.2975 11.029 18.5467 11.7409 17.6202 12.452C15.7552 13.8833 13.238 15.2653 10.5 15.2653C7.76198 15.2653 5.24477 13.8833 3.3798 12.452C2.4533 11.7409 1.70253 11.029 1.18376 10.495Z"
                        stroke="#477785"
                    />
                    <path
                        d="M14.2704 9.93012C14.2704 12.0165 12.579 13.7079 10.4926 13.7079C8.40621 13.7079 6.71484 12.0165 6.71484 9.93012C6.71484 7.84371 8.40621 6.15234 10.4926 6.15234C12.579 6.15234 14.2704 7.84371 14.2704 9.93012Z"
                        stroke="#477785"
                    />
                    <circle cx="9.13411" cy="8.5638" r="1.83333" stroke="#477785" />
                </svg>
            </button>
        </div>
    {/if}
</div>
